<template>
  <div>页面未实现</div>
</template>
<script>
export default {
  name: 'Header',
  components: {
  },
  data(){
    return {
    }
  },
  created: function () {
  },
  computed: {
  },
  watch: {
  },
  mounted: function(){
    console.log('页面未实现 mounted')
  },
  destroyed: function(){
    console.log('页面未实现 destroyed')
  },
  methods: {
  },
}
</script>